import { render } from "./slide30.vue?vue&type=template&id=947b8072&scoped=true"
import script from "./slide30.vue?vue&type=script&lang=js"
export * from "./slide30.vue?vue&type=script&lang=js"

import "./slide30.vue?vue&type=style&index=0&id=947b8072&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947b8072"]])

export default __exports__